import { IIssueChild, IIssueResponseBase } from '@kcftech/prometheustypescriptapiclient';
import { getFormattedIssueName } from 'pages/Desk/issues/shared';
import { useMemo } from 'react';

export function useIssueName(issue: IIssueResponseBase | IIssueChild | undefined) {
    return useMemo(() => (issue ? getFormattedIssueName(issue) : undefined), [issue]);
}
